var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.02356,0,0,5.02356,-2011.78,-2011.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.791,470.392C491.791,468.219 490.029,466.458 487.856,466.458C484.175,466.458 478.707,466.458 475.025,466.458C472.852,466.458 471.091,468.219 471.091,470.392C471.091,482.278 471.091,517.722 471.091,529.608C471.091,531.781 472.852,533.542 475.025,533.542C478.707,533.542 484.175,533.542 487.856,533.542C490.029,533.542 491.791,531.781 491.791,529.608C491.791,517.722 491.791,482.278 491.791,470.392ZM528.909,470.392C528.909,468.219 527.148,466.458 524.975,466.458C521.293,466.458 515.825,466.458 512.144,466.458C509.971,466.458 508.209,468.219 508.209,470.392C508.209,482.278 508.209,517.722 508.209,529.608C508.209,531.781 509.971,533.542 512.144,533.542C515.825,533.542 521.293,533.542 524.975,533.542C527.148,533.542 528.909,531.781 528.909,529.608C528.909,517.722 528.909,482.278 528.909,470.392Z",
    style: {
      fill: "white"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPause);
export default __webpack_public_path__ + "static/media/bigPause.3a3f8d8d.svg";
export { ForwardRef as ReactComponent };